export default __webpack_public_path__ + "static/media/delivered.f9456420.svg";